/* eslint-disable camelcase */
import ResourcePathManager from 'resource-path-manager';
const resourcePath = new ResourcePathManager();

/*
 * 'languagePath' is used for all URLs with some i18n support
 * use get(Safe)LanguagePath from languageHelper to fetch path string
 * include leading '/' here and use languageHelper util to get path string ('es/')
 */

const gamedayStaticQA = 'https://qa-gameday.mlbstatic.com';
const gamedayStaticBETA = 'https://beta-gameday.mlbstatic.com';
const gamedayStaticPROD = 'https://prod-gameday.mlbstatic.com';
const responsiveGamedayAssets = '/responsive-gameday-assets/1.3.0';
const mlbPROD = 'https://www.mlb.com';
const mlbDEV = 'https://dev-gcp.mlb.com';
const mlbQA = 'https://qa-gcp.mlb.com';
const mlbBETA = 'https://beta-gcp.mlb.com';
const milbPROD = 'https://www.milb.com';
const milbDEV = 'https://dev-gcp.milb.com';
const milbQA = 'https://qa-gcp.milb.com';
const milbBETA = 'https://beta-gcp.milb.com';
const tvLink = '/tv/g{game_pk}{mediaIdPath}/{date}?affiliateId=GAMEDAY';
const milbTVLink = '/live-stream-games/g{game_pk}?affiliateId=GAMEDAY';
const audioLink = '/tv/g{game_pk}?callsign={callSign}&affiliateId=GAMEDAY';
const milbAudio = '/live-stream-games/audio';
const playerPage = '/{languagePath}player/{pid}';
const gameday = '/{languagePath}gameday/{game_pk}';
const video = '{appPath}/{languagePath}video/{slug}';
const playerStory = '/{languagePath}stories/player/{playerId}';
const potgMFLQuery = '?mfl=gameday-final_wrap_potg';
const gamedayWrapExtension = '/final/wrap';
const gamedayBoxExtension = '/final/box';
const gamedayFinalVideoExtension = '/final/video';

resourcePath.set({
    recapLink: '{appPath}/{languagePath}news/{cid}?game_pk={game_pk}',
    playerPage,
    milbPlayerPage: {
        env_dev: milbDEV + playerPage,
        env_qa: milbQA + playerPage,
        env_beta: milbBETA + playerPage,
        env_prod: milbPROD + playerPage
    },
    mlbPlayerPage: {
        env_dev: mlbDEV + playerPage,
        env_qa: mlbQA + playerPage,
        env_beta: mlbBETA + playerPage,
        env_prod: mlbPROD + playerPage
    },
    playVideoLink: '{appPath}/{languagePath}video/{cid}',
    tvLink,
    audioLink,
    mlbtvLink: {
        env_dev: mlbDEV + tvLink,
        env_qa: mlbQA + tvLink,
        env_beta: mlbBETA + tvLink,
        env_prod: mlbPROD + tvLink
    },
    mlbAudioLink: {
        env_dev: mlbDEV + audioLink,
        env_qa: mlbQA + audioLink,
        env_beta: mlbBETA + audioLink,
        env_prod: mlbPROD + audioLink
    },
    milbAudioLink: {
        env_dev: milbDEV + milbAudio,
        env_qa: milbQA + milbAudio,
        env_beta: milbBETA + milbAudio,
        env_prod: milbPROD + milbAudio
    },
    milbtvLink: {
        env_dev: milbDEV + milbTVLink,
        env_qa: milbQA + milbTVLink,
        env_beta: milbBETA + milbTVLink,
        env_prod: milbPROD + milbTVLink
    },
    nativeAppShare: {
        env_dev: 'https://dev-gcp.mlb.com{path}',
        env_qa: 'https://qa-gcp.mlb.com{path}',
        env_beta: 'https://beta-gcp.mlb.com{path}',
        env_prod: 'https://www.mlb.com{path}'
    },
    dynamicFieldView: {
        env_local: 'https://wbcw-data-npd.mlb.com/dfv-{venueId}/main.m3u8',
        env_dev: 'https://wbcw-data-npd.mlb.com/dfv-{venueId}/main.m3u8',
        env_qa: 'https://wbcw-data-npd.mlb.com/dfv-{venueId}/main.m3u8',
        env_beta: 'https://wbcw-data-npd.mlb.com/dfv-{venueId}/main.m3u8',
        env_prod: 'https://wbcw-data.mlb.com/dfv-{venueId}/main.m3u8'
    },
    dynamicFieldViewDVR: {
        env_local: 'https://wbcw-data-npd.mlb.com/dfv-{venueId}/dvr/{gamePk}/main.m3u8',
        env_dev: 'https://wbcw-data-npd.mlb.com/dfv-{venueId}/dvr/{gamePk}/main.m3u8',
        env_qa: 'https://wbcw-data-npd.mlb.com/dfv-{venueId}/dvr/{gamePk}/main.m3u8',
        env_beta: 'https://wbcw-data.mlb.com/dfv-{venueId}/dvr/{gamePk}/main.m3u8',
        env_prod: 'https://wbcw-data.mlb.com/dfv-{venueId}/dvr/{gamePk}/main.m3u8'
    },
    batter: gamedayStaticPROD + responsiveGamedayAssets + '/images/batters/immortal/{stand}/{team:GENERIC}-{homeOrAway}.png',
    jersey: gamedayStaticPROD + responsiveGamedayAssets + '/images/batters/{year}/{stand}/{jerseyCode}.png',
    pants: gamedayStaticPROD + responsiveGamedayAssets + '/images/batters/{year}/{stand}/{pantsCode}.png',
    stadiumTop: {
        env_prod: gamedayStaticPROD + responsiveGamedayAssets + '/images/stadiums/{phase}/{id:default}{density}.jpg',
        env_beta: gamedayStaticBETA + responsiveGamedayAssets + '/images/stadiums/{phase}/{id:default}{density}.jpg',
        env_qa: gamedayStaticQA + responsiveGamedayAssets + '/images/stadiums/{phase}/{id:default}{density}.jpg'
    },
    stadiumBottom: gamedayStaticPROD + responsiveGamedayAssets + '/images/stadiums/infield-full/{id:default}{density}.jpg',
    headerLogo: 'https://www.mlbstatic.com/team-logos/league-on-{theme}/{id}.svg',
    homeRunDerby: 'https://www.mlb.com/gameday/home-run-derby/{xrefId}',
    videoShareUrl: {
        env_dev: 'https://dev-gcp.mlb.com/{languagePath}gameday/{gamePk}/video/{slug}',
        env_qa: 'https://qa-gcp.mlb.com/{languagePath}gameday/{gamePk}/video/{slug}',
        env_beta: 'https://beta-gcp.mlb.com/{languagePath}gameday/{gamePk}/video/{slug}',
        env_prod: 'https://www.mlb.com/{languagePath}gameday/{gamePk}/video/{slug}'
    },
    atBatShareUrl: {
        env_dev: 'https://dev-gcp.mlb.com/{languagePath}gameday/{gamePk}/play/{id}',
        env_qa: 'https://qa-gcp.mlb.com/{languagePath}gameday/{gamePk}/play/{id}',
        env_beta: 'https://beta-gcp.mlb.com/{languagePath}gameday/{gamePk}/play/{id}',
        env_prod: 'https://www.mlb.com/{languagePath}gameday/{gamePk}/play/{id}'
    },
    gamedayLink: {
        env_dev: mlbDEV + gameday,
        env_qa: mlbQA + gameday,
        env_beta: mlbBETA + gameday,
        env_prod: mlbPROD + gameday
    },
    gamedayVideoLink: {
        env_dev: mlbDEV + gameday + gamedayFinalVideoExtension,
        env_qa: mlbQA + gameday + gamedayFinalVideoExtension,
        env_beta: mlbBETA + gameday + gamedayFinalVideoExtension,
        env_prod: mlbPROD + gameday + gamedayFinalVideoExtension
    },
    gamedayBoxLink: {
        env_dev: mlbDEV + gameday + gamedayBoxExtension,
        env_qa: mlbQA + gameday + gamedayBoxExtension,
        env_beta: mlbBETA + gameday + gamedayBoxExtension,
        env_prod: mlbPROD + gameday + gamedayBoxExtension
    },
    gamedayWrapLink: {
        env_dev: mlbDEV + gameday + gamedayWrapExtension,
        env_qa: mlbQA + gameday + gamedayWrapExtension,
        env_beta: mlbBETA + gameday + gamedayWrapExtension,
        env_prod: mlbPROD + gameday + gamedayWrapExtension
    },
    videoLink: {
        env_dev: mlbDEV + video,
        env_qa: mlbQA + video,
        env_beta: mlbBETA + video,
        env_prod: mlbPROD + video
    },
    playerOfTheGame: `https://www.mlb.com/apps/player-of-the-game/game/{languagePath}contest/{gamePk}${potgMFLQuery}`,
    playerOfTheGameLeaderboard: `https://www.mlb.com/apps/player-of-the-game/game/{languagePath}leaderboard${potgMFLQuery}`,
    playerOfTheGameArtwork: {
        env_prod: gamedayStaticPROD + responsiveGamedayAssets + '/images/promotions/player-of-the-game/artwork-{theme}-{language}.svg',
        env_beta: gamedayStaticBETA + responsiveGamedayAssets + '/images/promotions/player-of-the-game/artwork-{theme}-{language}.svg',
        env_qa: gamedayStaticQA + responsiveGamedayAssets + '/images/promotions/player-of-the-game/artwork-{theme}-{language}.svg'
    },
    playerStory: mlbPROD + playerStory,
    playerActionShot: 'https://img.mlbstatic.com/mlb-photos/image/upload/{optionsPath}v1/people/{playerId}/action/vertical/current',
    teamUrl: '/{languagePath}{slug}'
});

export { resourcePath };
